// The report link's landing (Adam, 30 Oct 2026). Email 1's "See your report" link is /property-strategy/report.
// Logged out, it shows the Library's door, and the login lands on the Library as every login does (decision 29). For
// that 1 path the Library then opens with a line at the top saying the report is ready and 1 button to open it, so the
// person lands inside their account, sees what else is there, and is 1 click from their report.
//
// App.jsx marks the landing while it renders the fresh login on the report path (before the Library's own effects
// run); the Library reads it once and the button clears it. It lives in this tab's sessionStorage only, so a reload
// keeps the line until it's used, and another tab or a later visit doesn't show it. Storage that throws (a private
// window on some browsers) means no line, never an error.
const KEY = 'hub-report-landing'

// The line's words (Adam, 30 Oct 2026)
export const REPORT_READY = {
  text: 'Your property strategy report is ready.',
  button: 'Open your report',
}

export function markReportLanding() {
  try { sessionStorage.setItem(KEY, '1') } catch { /* no storage, no line */ }
}

export function hasReportLanding() {
  try { return sessionStorage.getItem(KEY) === '1' } catch { return false }
}

export function clearReportLanding() {
  try { sessionStorage.removeItem(KEY) } catch { /* nothing to clear */ }
}
